import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FolderService } from "../../../_services/folder.service";
import { ErrorUtil } from "src/app/_utilities/error";
import {ReportService} from "../../../_services/report.service";
import { NgxSpinnerService } from 'ngx-spinner';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';

@Component({
    selector: 'app-report-duplicate',
    templateUrl: './report-duplicate.component.html',
    styleUrls: ['./report-duplicate.component.scss'],
    standalone: false
})
export class ReportDuplicateComponent implements OnInit {
  folders: any = [];

selectedFolder: any = null;
previousFolder: any = null;
currentFolder: string;
data: any;
selectedReportName: string;
folderList: any  =[];
firstScreen: boolean = true;
secondScreen: boolean = false;
translate: any;

  constructor(
      public modalRef : BsModalRef, private folderService: FolderService, private errorUtil: ErrorUtil, 
      private reportService: ReportService, private spinner: NgxSpinnerService,
      private languageTranslateService: LanguageTranslateService
  ) {
    console.log(this.data, 'data printing in duplicat report')
   }

  ngOnInit(): void {
    console.log(this.data, 'data printing in duplicate modal')
    this.currentFolder = this.data?.folderName;
    this.selectedReportName = this.data?.name+'(2)';
    this.getFolderList();
    this.languageTranslateService.wordSrc$.subscribe(transData => {
      if (Object.keys(transData).length != 0) {
        this.translate = transData;
      }
    })
  }

  onFolderClick(item: any){
    console.log(item, 'folder clicked')
    console.log(this.selectedFolder);
    if (this.selectedFolder?.children?.length > 0){
      //update the folders to display sub folders value
      this.folders = item.children;
      if (!this.previousFolder){
        //save the previous folder value only once
        this.previousFolder = this.selectedFolder;
      }

      this.firstScreen = false;
      this.secondScreen = true;
      //this.selectedFolder = null;
    }
    
  }

  goBackOneFolderAbove(){
    this.folders = this.folderList;
    this.folders = this.folders.filter((f:any) => { return f.name !== 'Favorites' && f.name !== 'Standard Reports' });

    this.selectedFolder = null;
    console.log(this.selectedFolder, 'selected folder')
    console.log(this.previousFolder, 'previous folder')
    this.firstScreen = true;//dont show the back button in first screen
    this.secondScreen = false;
  }

  getFolderList(){
    this.folderService.getFoldersList().subscribe( (res: any) => {
      console.log(res, 'res pringint from GET folders api')
      console.log(this.folders, 'folders in duplicate');
      this.folders = res.body;
      //reports are not allowed to duplicate to Favorites and Standard Reports folders
      this.folders = this.folders.filter((f:any) => { return f.name !== 'Favorites' && f.name !== 'Standard Reports' });
      this.folderList = res.body;
      //by default, the first folde will be selected
      this.selectedFolder = this.folders[0];
      
    },
    (err: any)=>{
      console.log(err, 'err printing..')
      this.errorUtil.setErrorMessage(
        err.status,
        err.error ? err.error.title : null,
        err.error ? err.error.title : null,
        "error",
        2000
      );
    })
  }

  onDuplicateSave(){
    let params: any = {
      "duplicateReportId": this.data.id,
      "reportName": this.selectedReportName,
      "folder": {
        "id": this.selectedFolder.id
      }
    };

    this.spinner.show();

    this.reportService.duplicateReport(params).subscribe((res:any)=>{
      this.spinner.hide();
      console.log(res, 'report duplicate api response printing..')
      if (res.status == 200){
        this.errorUtil.setErrorMessage(
          200,
          this.translate.report.label.singular + ' ' + this.translate.report.validationFE.duplicatedSuccesfully,
          null,
          "success",
          2000
        );
        this.modalRef.hide();
      }
    }, 
    (err:any) =>{
       this.spinner.hide();
      console.log(err, 'error in report duplicate api')
      this.errorUtil.setErrorMessage(
        err.status,
        err.error ? err.error.title : null,
        err.error ? err.error.title : null,
        "error",
        2000
      );
    });
  }
}
